import React, { memo, useEffect, useRef, useState } from "react";

const safeCount = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return 0;
    return Math.max(0, num);
};

const CountDownTimerMobile = ({
                                  countDownTimer = 0,
                                  totalResult = 0,
                                  drawCode = "",
                                  onLastTenSecond,
                                  onCancelBetting,
                              }) => {
    const [count, setCount] = useState(safeCount(countDownTimer));

    const intervalRef = useRef(null);
    const prevDrawCodeRef = useRef(drawCode);
    const prevCountRef = useRef(safeCount(countDownTimer));

    // Reset when new draw arrives or incoming timer changes
    useEffect(() => {
        const nextCount = safeCount(countDownTimer);

        if (prevDrawCodeRef.current !== drawCode) {
            prevDrawCodeRef.current = drawCode;
            setCount(nextCount);
            prevCountRef.current = nextCount;
            return;
        }

        // Optional: keep state synced if backend sends updated countdown
        setCount((prev) => (prev !== nextCount ? nextCount : prev));
    }, [drawCode, countDownTimer]);

    // Start timer
    useEffect(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
            setCount((prev) => Math.max(0, prev - 1));
        }, 1000);

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [drawCode]);

    // Handle side effects safely
    useEffect(() => {
        const prev = prevCountRef.current;

        if (prev !== count) {
            if (count <= 10 && count > 0 && onLastTenSecond) {
                onLastTenSecond(count);
            }

            if (prev > 10 && count === 10 && onCancelBetting) {
                onCancelBetting();
            }
        }

        prevCountRef.current = count;
    }, [count, onLastTenSecond, onCancelBetting]);

    const safeTotalResult = safeCount(totalResult);
    const displayValue = safeTotalResult > 0 ? safeTotalResult : safeCount(count);

    return (
        <div className="bg-danger d-flex justify-content-center align-items-center count-down w-100">
            {displayValue}
        </div>
    );
};

export default memo(CountDownTimerMobile);